module.exports = __webpack_public_path__ + "static/media/3_2_markdown.5ba6aedf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/3_2_markdown.jpg
// module id = 312
// module chunks = 0